import * as React from "react";
import { forwardRef } from "react";
const SvgX = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "#1F2D67", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-x-icon lucide-x", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18 6 6 18" }), /* @__PURE__ */ React.createElement("path", { d: "m6 6 12 12" }));
const ForwardRef = forwardRef(SvgX);
export default ForwardRef;
